import { useIntl } from "react-intl";
import { PageTitle } from "../../../components/page-title/PageTitle";
import React, { useState } from "react";
import { Button, Steps } from "antd";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({}));

export const UpdateInformation = (props: any) => {
  const classes = useStyles(props);
  const intl = useIntl();

  const { Step } = Steps;

  const [current, setCurrent] = useState(0);

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const steps = [
    {
      title: "First",
      content: "First-content",
    },
    {
      title: "Second",
      content: "Second-content",
    },
  ];
  return (
    <>
      <PageTitle
        title={intl.formatMessage({ id: "sharedScreen.updateInformation" })}
      />

      <Steps current={current}>
        {steps.map((item) => (
          <Step key={item.title} title={item.title} />
        ))}
      </Steps>
      <div className="steps-content">{steps[current].content}</div>
      <div className="steps-action">
        {current < steps.length - 1 && (
          <Button type="primary" onClick={() => next()}>
            Next
          </Button>
        )}
        {/*{current === steps.length - 1 && (*/}
        {/*    <Button type="primary" onClick={() => message.success('Processing complete!')}>*/}
        {/*        Done*/}
        {/*    </Button>*/}
        {/*)}*/}
        {current > 0 && (
          <Button style={{ margin: "0 8px" }} onClick={() => prev()}>
            Previous
          </Button>
        )}
      </div>
    </>
  );
};

UpdateInformation.routeName = "/update-information";
